import { useEffect, useState } from 'react'

import { default as Statuses } from '@cinch/oxd-utils/request-status/src'
import { WbacService } from '@cinch/oxd-utils/requests/src'
import * as Storage from '@cinch/oxd-utils/storage/src'

const useToken = () => {
  const [token, setToken] = useState<string>('')
  const [status, setStatus] = useState<string>(Statuses.INITIAL)

  useEffect(() => {
    const authenticate = async () => {
      const result = await WbacService.post('/authentication')

      return result.data
    }

    const { token: storageToken } = Storage.get(Storage.StorageKeys.wbac)

    if (storageToken) {
      setStatus(Statuses.SUCCESS)
      setToken(storageToken)
    } else {
      setStatus(Statuses.PENDING)
      authenticate()
        .then((response) => {
          Storage.update(Storage.StorageKeys.wbac, { token: response })
          setToken(response)
          setStatus(Statuses.SUCCESS)
        })
        .catch(() => setStatus(Statuses.ERROR))
    }
  }, [])

  return {
    token,
    status,
  }
}

export default useToken
